import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { AppCommonsModule } from "src/app/commons/app-commons.module";
import { PlessSharedModule } from "src/app/shared/pless-shared.module";
import { KYMW6902Component } from "./kymw6902.component";
import { GetGoodsListService } from "./api-services/get-goods-list.service";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WjNavModule,
    WjGridModule,
    AppCommonsModule,
    PlessSharedModule,
  ],
  declarations: [KYMW6902Component],
  providers: [
    GetGoodsListService
  ],
})
export class KYMW6902Module { }